import { render, staticRenderFns } from "./CooldownLabelButton.vue?vue&type=template&id=65b8052e&scoped=true"
import script from "./CooldownLabelButton.vue?vue&type=script&lang=ts"
export * from "./CooldownLabelButton.vue?vue&type=script&lang=ts"
import style0 from "./CooldownLabelButton.vue?vue&type=style&index=0&id=65b8052e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b8052e",
  null
  
)

export default component.exports